<template>
    <div class="article">
        <!-- ============= 顶部背景图 ============= -->
        <div class="top-img">
            <img src="../../assets/images/news/zhuangshitu.png" style="width: 100%;">
            <div class="img-title">
                <span style="font-size: 32px">中国最具成长性半导体企业评选</span>
                <p style="color: rgba(153,153,153,1)">Selection of the Most Growing Semiconductor Enterprises in China</p>
            </div>
        </div>

        <!-- ============= 知识文章搜索栏 ============= -->
        <div class="article-search" style="padding: 20px">
            <el-row :gutter="24" style="margin-top: 40px">
                <!-- 左侧推荐文章 -->
                <el-col :span="8">
                    <div class="left-title">
                        <div class="title-input">
                          <el-input placeholder="搜索" prefix-icon="el-icon-search" v-model="title"></el-input>
                        </div>

                        <div class="title-Data" style="margin-top: 40px">
                            <span class="recommend-article" style="margin-bottom: 40px;display: block">推荐文章</span>
                            <div class="article-item"  v-for="(item , index) in news_shows" :key="index"><a>{{item.new_tit}}</a><p class="title-p">{{item.new_have}}</p></div>
                        </div>

                        <div class="title-tree" style="margin-top: 40px">
                            <div>分类目录</div>
                            <div style="margin-top: 20px">
                                <el-tree :data="tit" :props="defaultProps" @node-click="handleNodeClick"  :default-expanded-keys="2" ></el-tree>
                            </div>
                            <div style="margin-top: 40px;cursor: pointer" @click="reload"><a>其他资料更新</a></div>
                        </div>
                    </div>
                </el-col>

                <!-- 知识文章内容 -->
                <el-col :span="16">
                    <!--div>
                      <img src="../../assets/images/news/Bitmap.png" style="display: block">
                    </div-->

                    <div class="article-content" style="width: 889px "  v-if="news!=''">
                        <h2>{{news[0].new_tit}}</h2>
                        <p style="color: rgba(51,51,51,1);">{{news[0].new_have}}</p>
                      <p v-html="news[0].new_show">{{news[0].new_show}}</p>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data: [{
                  id: 1,
                  label: '技术纹章(10)',
                  children: [{
                    label: '二级 1-1',
                    children: [{
                      label: '三级 1-1-1'
                    }]
                  }]
                }, {
                  id: 2,
                  label: '企业(3)',
                  children: [{
                    label: 'SH79F6441 用户指南已经更新',
                  }, {
                    label: 'ET51与JET51A差异说明',
                  }, {
                    label: '动力锂电池BMS简介',
                  }]
                }, {
                  label: '动力锂电池BMS简介',
                  children: [{
                    label: '二级 3-1',

                  }, {
                    label: '二级 3-2',
                  }]
                }],
                defaultProps: {
                  children: 'show_news',
                  label: 'type_name'
                },
                tit: [],  // 分类目录
                news: [],  // 新闻详情
                news_shows: [], // 推荐文章
            }
        },
        methods: {
            handleNodeClick(data) {
                window.location="article?new_id="+data.type_id;
            },
            reload:function () {
                window.location.reload();
            },
            getArticle(){ // 获取信息列表
                let new_id=this.get_get_val('new_id');
                this.$axios({
                    method:'get',
                    url:'/api/pre/json_go/look_news?type=3&new_type_id=70&new_id='+new_id,
                }).then((response) =>{
                    this.tit = response.data.tit
                    this.news = response.data.news
                    this.news_shows = response.data.news_shows
                    // 改新闻详情分类目录二级菜单的属性名
                    this.tit= JSON.parse(JSON.stringify(this.tit).replace(/new_tit/g,"type_name"));
                }).catch((error) =>
                    console.log(error)       //请求失败返回的数据
                )
            },
            get_get_val:function (get_name){
                // 获取参数type_id的值
                var reg = new RegExp("(^|&)" + get_name + "=([^&]*)(&|$)");
                var r = window.location.search.substr(1).match(reg);
                if (r != null){
                    return decodeURI(r[2]);
                }else{
                    return '';
                }
            },
        },
        mounted() {
            this.getArticle()
        }
    };
</script>

<style >
    .article .top-img { position: relative;width: 100% }
    .article .img-title { position: absolute;top: 30%;left: 40% }
    .article .left-title { width: 240px;margin-left: 35%  }
    .article .title-p { color: rgba(153,153,153,1);font-size: 14px }
    .article .content-span { color: rgba(153,153,153,1);font-size: 18px }
    .article .content-p { color: rgba(153,153,153,1);font-size: 18px }
</style>



// WEBPACK FOOTER //
// src/pages/news/article.vue